import './polyfills';
import 'regenerator-runtime/runtime.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initClientData } from './reducers/client';
import { initAdvisorData } from './reducers/advisor';
import { initParams } from './reducers/params';
import App from './components/App/App';
import './index.css';

//HEY SONAR
// the id of the div to render too
let appId = 'bhvfin';

// set the apiURL from env variable
initParams.apiURL = `${process.env.REACT_APP_API_URL}`;

// set the default params used for DEV
initParams.mode = ''; // client|advisor
initParams.clientID = ''; // 5d94bc68d72fc84e93885648
initParams.advisorEmail = ''; // advisor@test.com
initParams.advisorFirstName = '';
initParams.advisorLastName = '';
initParams.token = ''; // 78aa762565cd2b217da7d10ef2a22b07769236244c3f91ce40453867fcdf6baa

// set mode from window.bhvfin
if (window.bhvfin) {
  initParams.mode = window.bhvfin.mode;
  initParams.pdfEnabled = window.bhvfin.pdfEnabled === 'True' ? true : false;
}

// optionally set clientID from URL param
initParams.clientID = window.location.search.toLowerCase().split('clientid=')[1] || initParams.clientID;
if (initParams.clientID !== '') {
  initParams.mode = 'client';
}

// if wt.com set advisor email, name, & token from window.portfolioMapper
if (window.portfolioMapper) {
  initParams.advisorEmail = window.portfolioMapper.clientEmail;
  initParams.advisorFirstName = window.portfolioMapper.firstName;
  initParams.advisorLastName = window.portfolioMapper.lastName;
  initParams.token = window.portfolioMapper.token;
}

// optionally set appId from script tag
function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script');
  const lastScript = scripts[scripts.length - 1];
  const scriptName = lastScript;
  // override attributes if they exist
  if (scriptName.getAttribute('appId')) {
    appId = scriptName.getAttribute('appId');
  }
}
getSyncScriptParams();

// render
ReactDOM.render((
  <Provider
    store={createStore(
      reducers,
      {
        'clientData': initClientData,
        'advisorData': initAdvisorData,
        'params': initParams,
      },
      applyMiddleware(thunk)
    )}
  >
    <App />
  </Provider>
), document.getElementById(appId));



// WEBPACK FOOTER //
// ./src/index.js